import { Component, Host, h, Prop, Element, Watch } from '@stencil/core';
import * as echarts from 'echarts';

type EChartsOption = echarts.EChartsOption;

export interface ChartData {
  xData: string[] | number[];
  yData: string[] | number[];
}

const defaultOptions: EChartsOption = {
  title: [{
    text: '',
    left: 'center'
  }],
  xAxis: [{
    type: 'category',
    data: []
  }],
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: [],
      type: 'bar',
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)'
      }
    }
  ]
};

@Component({
  tag: 'cr-bar-chart',
  styleUrl: 'cr-bar-chart.css',
  shadow: true,
})

export class CrBarChart {
  chartDom: any;
  eChart: echarts.ECharts;
  width: string = '500px';
  height: string = '500px';
  chartOptions: EChartsOption = defaultOptions;

  @Element() el: HTMLElement;

  @Prop() chartTitle: string = ""
  @Prop() showBackground: boolean = true
  @Prop() chartData: ChartData = {
    xData: [],
    yData: [],
  };

  @Watch('chartTitle')
  @Watch('showBackground')
  @Watch('chartData')
  updateChart(newValue, oldValue) {
    if (this.isObject(newValue)) {
      this.setChartData()
    } else {
      if (newValue !== oldValue)
        this.setChartAttributes()
    }
  }

  connectedCallback() {
    this.width = this.el.parentElement.style.width || this.el.parentElement.clientWidth + 'px';
    this.height = this.el.parentElement.style.height || this.el.parentElement.clientHeight + 'px';
  }

  componentDidLoad() {
    this.eChart = echarts.init(this.chartDom);
    this.setChartData()
    this.setChartAttributes()
  }

  render() {
    return (
      <Host>
        <div style={{ height: this.height, width: this.width }} ref={el => (this.chartDom = el as HTMLDivElement)}></div>
      </Host>
    );
  }

  private setChartData = () => {
    this.chartOptions.xAxis[0].data = this.chartData.xData
    this.chartOptions.series[0].data = this.chartData.yData
    this.eChart.setOption(this.chartOptions)
  }

  private setChartAttributes = () => {
    this.chartOptions.title[0].text = this.chartTitle
    this.chartOptions.series[0].showBackground = this.showBackground
    this.eChart.setOption(this.chartOptions)
  }

  private isObject = (value: any) => {
    return (typeof value === 'object' &&
      !Array.isArray(value) &&
      value !== null)
  }
}
